import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Suppress only interaction_in_progress errors at all console levels
const shouldFilter = (args: any[]) => {
  const message = args.map(arg => arg?.toString?.() || '').join(' ');
  return message.includes('interaction_in_progress') || message.includes('Interaction is currently in progress');
};

const originalError = console.error;
const originalWarn = console.warn;
const originalLog = console.log;
const originalInfo = console.info;

console.error = function(...args: any[]) {
  if (!shouldFilter(args)) originalError.apply(console, args);
};

console.warn = function(...args: any[]) {
  if (!shouldFilter(args)) originalWarn.apply(console, args);
};

console.log = function(...args: any[]) {
  if (!shouldFilter(args)) originalLog.apply(console, args);
};

console.info = function(...args: any[]) {
  if (!shouldFilter(args)) originalInfo.apply(console, args);
};

// Also catch unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  const message = event.reason?.toString?.() || '';
  if (message.includes('interaction_in_progress') || message.includes('Interaction is currently in progress')) {
    event.preventDefault(); // Prevent the error from being logged
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
